import styled from 'styled-components';
import Tab from '@material-ui/core/Tab';
import Spinner from '@material-ui/core/CircularProgress';
export const LeftTabNav = styled.div`
  float: left;
  height: 100%;
  border: 1px solid #eaeaea;
  width: 17%;
  position: relative;
  display: flex;
  flex-direction: column;
  border-top: none;
  padding: 10px 13px;
  .MuiTabs-root {
    border-bottom: none !important;
  }
`;
export const RightTabNav = styled.div`
  float: left;
  display: flex;
  width: 83%;
  flex-direction: column;
  padding: 10px;
`;
export const StyledTab = styled(Tab)`
  && {
    font-size: 13px;
    text-transform: none;
    display: flex;
    align-content: flex-start;
    width: 100%;
    color: #2f2f2e;
    overflow: hidden;
    font-family: 'OpenSans-Regular';
    padding: 0px 12px;
    min-width: 100%;
    span {
      display: inline-block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      text-align: left;
    }
  }
  &.Mui-selected {
    background-color: #eff3f8 !important;
    font-family: 'OpenSans-Light';
  }
`;
export const StyledSpinner = styled(Spinner)`
  && {
    margin-left: 40%;
    margin-top: 10%;
  }
`;
export const StyledMyTab = styled(Tab)`
  && {
    font-size: 13px;
    text-transform: none;
    display: flex;
    align-content: flex-start;
    font-family: 'OpenSans-Regular';
    width: 100%;
    color: #2f2f2e;
    overflow: hidden;
    padding: 0px 12px;
    min-width: 100%;
    span {
      display: inline-block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      text-align: left;
    }
  }
  &.Mui-selected {
    background-color: #eff3f8 !important;
    font-family: 'OpenSans-Light';
  }
`;
export const StyledWrapper = styled.div`
  height: 100%;
  background: white;
  padding: 0px 48px;
`;